import { render, staticRenderFns } from "./RichTextArea.vue?vue&type=template&id=83084832&scoped=true"
import script from "./RichTextArea.vue?vue&type=script&lang=js"
export * from "./RichTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83084832",
  null
  
)

export default component.exports